import React, { createContext, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

const routeConfig = {
    '/': { label: 'Home', parent: null },
    '/dashboard': { label: 'Dashboard', parent: '/' },
    '/products': { label: 'Products', parent: '/dashboard' },
    '/categories': { label: 'Categories', parent: '/dashboard' },
    '/orders': { label: 'Orders', parent: '/dashboard' },
    '/create-order': { label: 'Create Order', parent: '/dashboard' },
    '/add-product': { label: 'Add Product', parent: '/products' },
    '/add-party': { label: 'Add Party', parent: '/dashboard' },
    '/view-parties': { label: 'View Parties', parent: '/dashboard' },
    '/register-user': { label: 'Register User', parent: '/dashboard' },
    '/registered-users': { label: 'Users', parent: '/dashboard' },
    '/statistics': { label: 'Statistics', parent: '/dashboard' },
    '/profile': { label: 'Profile', parent: '/dashboard' },
    '/assigned-deliveries': { label: 'Assigned Deliveries', parent: '/dashboard' }
};

export const NavigationProvider = ({ children }) => {
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState('');

    const getBreadcrumbs = () => {
        const paths = [];
        let currentPath = location.pathname;

        while (currentPath) {
            const route = routeConfig[currentPath];
            if (!route) break;

            paths.unshift({
                path: currentPath,
                label: route.label
            });

            currentPath = route.parent;
        }

        return paths;
    };

    return (
        <NavigationContext.Provider value={{
            currentPath: location.pathname,
            breadcrumbs: getBreadcrumbs(),
            pageTitle,
            setPageTitle
        }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
};